import { render } from "./TypingIndicator.vue?vue&type=template&id=2226ef17&scoped=true"
const script = {}

import "./TypingIndicator.vue?vue&type=style&index=0&id=2226ef17&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2226ef17"]])

export default __exports__